export const GET_TASKS_LIST = 'tasksList/GET_TASKS_LIST'
export const SET_TASKS_LIST = 'tasksList/SET_TASKS_LIST'

export const IS_TASK_LIST_LOADING = 'tasksList/IS_TASK_LIST_LOADING'
